export var addressController = function($scope, $window, AutoCompleteAddress, configManager, AccountConfigManager) {
    var self = this;
    // Get Market-specific data for the view
    var addressConfigs = self.addressConfigs.addressRequirements;

    if (self.countryCode === 'HK') {
        self.stateList = [{
            'name': self.translations.marketSelectHK,
            'abbreviation': self.translations.marketSelectHK
        }, {
            'name': self.translations.marketSelectMO,
            'abbreviation': self.translations.marketSelectMO
        }];
    } else {
        self.stateList = addressConfigs.state.stateList;
    }

    self.zipMaxLength = addressConfigs.postalCode.maxLength;
    self.zipMinLength = addressConfigs.postalCode.minLength;
    self.dropdown = addressConfigs.state.dropdown;
    self.showErrorBlock1 = addressConfigs.postalCode.showErrorBlock1;
    self.showErrorBlock2 = addressConfigs.postalCode.showErrorBlock2;
    self.showState = addressConfigs.state.show;
    self.showZip = addressConfigs.postalCode.showZip;
    self.streetNumRequired = addressConfigs.streetNumRequired;

    self.showFieldsFullWidth = function(view, screen) {
        // This accounts for mid sized screens such as iPad
        if (screen > 500 && screen < 850) {
            return addressConfigs.fullWidthIpad;
        }
        switch (view) {
        case 'signup':
            return true;
        case 'account-desktop':
            return addressConfigs.fullWidthDesktop;
        case 'account-mobile':
            return true;
        default:
            return true;
        }
    };

    self.showFullWidth = self.showFieldsFullWidth(self.addressView, $window.innerWidth);

    angular.element($window).bind('resize', function() {
        self.showFullWidth = self.showFieldsFullWidth(self.addressView, $window.innerWidth);
    });

    var accountConfigManager = AccountConfigManager.getConfig(configManager);
    // Google Configs
    var googlePlacesApiUrl = 'https://maps.googleapis.com/maps/api/js';
    var googlePlacesApiQueryParameter = '&libraries=places';
    var googlePlacesApiServerKey = accountConfigManager.system['googlePlacesApiServerKey'];
    var googleAutoComplete = accountConfigManager.system['googlePlacesOnOffFlag'];

    self.showStreetNumError = false;
    var autocomplete;

    self.initAutocomplete = function() {
        var googleApiId = angular.element('#googleApi');
        if (googleApiId.length < 1 && googleAutoComplete) {
            self.buildGoogleMapsScriptTag();
        }
    };

    self.buildGoogleMapsScriptTag = function() {
        var script = document.createElement('script');
        script.setAttribute('src', googlePlacesApiUrl + '?key=' + googlePlacesApiServerKey
            + googlePlacesApiQueryParameter);
        script.setAttribute('async', 'async');
        script.setAttribute('defer', 'defer');
        script.setAttribute('id', 'googleApi');
        document.head.appendChild(script);
    };

    self.triggerAutocomplete = function() {
        if (googleAutoComplete
            && angular.element('#' + self.addressView + '-streetAddress').val().length >= 2) {
            if (angular.element('#' + self.addressView + '-streetAddress').val().length == 2) {
                angular.element('.pac-container').addClass('ng-hide');
            } else {
                angular.element('.pac-container').removeClass('ng-hide');
            }
            if ((typeof google === 'undefined' ? 'undefined' : typeof(google)) === 'object'
                && autocomplete == undefined) {
                autocomplete = new google.maps.places.Autocomplete(
                    /** @type {!HTMLInputElement} */(document.getElementById(self.addressView + '-streetAddress')),
                    {types: ['geocode'], componentRestrictions: {country: self.countryCode}});
                autocomplete.addListener('place_changed', self.fillInAddress);
            }
        } else {
            if (autocomplete !== undefined && google !== undefined) {
                angular.element('.pac-container').addClass('ng-hide');
            }
        }
    };

    self.fillInAddress = function() {
        var place = autocomplete.getPlace();
        var newAddress = new AutoCompleteAddress(place);
        // if the street number is not required, or if there is a street number, format and autocomplete
        // else, do not autocomplete and throw a no street number error
        if (newAddress && (!self.streetNumRequired || newAddress.streetNumber)) {
            self.clearAllFields();
            var formattedAddress = self.addressFormatter.formatAutoCompleteAddress(newAddress);
            self.populateAllFields(formattedAddress);
        } else {
            self.showStreetNumError = true;
            self.address.streetAddress = '';
        }
        $scope.$apply();
    };

    self.clearAllFields = function() {
        self.address = {};
        $scope.$apply();
    };

    self.populateAllFields = function(googleApiResults) {
        self.clearAllFields();
        // Match the state name to it's abbreviation for dropdown
        if (self.stateList && googleApiResults.state) {
            var stateSearchIndex = self.stateList.findIndex(function(obj) {
                return obj.name.toUpperCase() === googleApiResults.state.toUpperCase();
            });
            if (stateSearchIndex > -1) {
                googleApiResults.state = self.stateList[stateSearchIndex].abbreviation;
            }
        }
        self.address = googleApiResults;
    };
};



//////////////////
// WEBPACK FOOTER
// /Users/geoffsagers/dev/webcomponents/js/packages/common-account/src/angular/directives/address/address-controller.js
// module id = 264
// module chunks = 0